import styled from 'styled-components';

import { useGetTrackingSummary } from 'hooks/queries/tracking';
import CoreLoading from 'shared/CoreLoading';
import {
	EmphasizeText,
	ReportSection,
	ReportSectionCard,
	ReportSectionHeader,
	ReportTopHeader,
} from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

interface ITrackingSummaryCards {
	code: string;
}

const formatDateFull = (dateStr: string) => {
	if (!dateStr) return '';
	const d = new Date(dateStr);
	if (isNaN(d.getTime())) return '';
	const yyyy = String(d.getFullYear());
	const mm = String(d.getMonth() + 1).padStart(2, '0');
	const dd = String(d.getDate()).padStart(2, '0');
	return `${yyyy}.${mm}.${dd}`;
};

const TrackingSummaryCards = ({ code }: ITrackingSummaryCards) => {
	const { data: summary, isLoading } = useGetTrackingSummary(code);

	if (isLoading) {
		return (
			<ReportSection>
				<Grid flex="center" _height="120px">
					<CoreLoading color_type="black" size_type="large" />
				</Grid>
			</ReportSection>
		);
	}

	const dateRange = summary
		? `${formatDateFull(summary.trackingStartDate)} ~ ${formatDateFull(
				summary.trackingEndDate,
		  )}`
		: '-';

	return (
		<ReportSection _margin="0">
			<ReportSectionHeader>현황</ReportSectionHeader>
			<CardGrid>
				<ReportSectionCard _padding="24px">
					<ReportTopHeader>참여 크리에이터 수</ReportTopHeader>
					<EmphasizeText>
						<span>
							{summary ? (summary.participantCreatorCount ?? 0).toLocaleString() : '-'}
							{summary && <Unit> 명</Unit>}
						</span>
					</EmphasizeText>
				</ReportSectionCard>

				<ReportSectionCard _padding="24px">
					<ReportTopHeader>수집 기간</ReportTopHeader>
					<EmphasizeText>
						<span>
							{dateRange}
							{summary && summary.trackingDays != null && (
								<Unit> (총 {summary.trackingDays}일)</Unit>
							)}
						</span>
					</EmphasizeText>
					{summary && summary.collectionRetentionDays != null && (
						<SubText>
							콘텐츠별 {summary.collectionRetentionDays}일간 수집
						</SubText>
					)}
				</ReportSectionCard>

				<ReportSectionCard _padding="24px">
					<ReportTopHeader>콘텐츠 수</ReportTopHeader>
					<EmphasizeText>
						<span>
							{summary ? (summary.contentCount ?? 0).toLocaleString() : '-'}
							{summary && <Unit> 개</Unit>}
						</span>
					</EmphasizeText>
				</ReportSectionCard>
			</CardGrid>
		</ReportSection>
	);
};

const CardGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 2.5fr 1fr;
	gap: 16px;
`;

const Unit = styled.span`
	font-size: 14px !important;
	font-weight: 400 !important;
	color: ${({ theme }) => theme.colors.gray.gray50} !important;
`;

const SubText = styled.p`
	margin: 4px 0 0;
	font-size: 13px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.gray.gray50};
`;

const { Grid } = style;

export default TrackingSummaryCards;
